var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroImageEditeIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.003,
    height: 24.003,
    viewBox: "0 0 24.003 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29489",
    "data-name": "Group 29489",
    transform: "translate(-0.517 -0.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40186",
    "data-name": "Path 40186",
    d: "M23.023,8.544a.8.8,0,0,0-.537,1,10.4,10.4,0,1,1-7.007-7.008A.8.8,0,1,0,15.936,1a12,12,0,1,0,8.085,8.084.8.8,0,0,0-1-.536Z",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40187",
    "data-name": "Path 40187",
    d: "M5.735,12.489l-.391,1.525a2.316,2.316,0,0,0,.54,2.245,2.205,2.205,0,0,0,1.578.627,2.689,2.689,0,0,0,.669-.086l1.524-.391a3.187,3.187,0,0,0,1.455-.845l9.575-9.574a2.648,2.648,0,0,0,.3-3.7L19.855,1.156a2.647,2.647,0,0,0-3.7.3L6.581,11.034a3.183,3.183,0,0,0-.846,1.455ZM6.9,14.411l.391-1.524a1.606,1.606,0,0,1,.425-.721l9.575-9.575a1.456,1.456,0,0,1,.989-.46.625.625,0,0,1,.447.156l1.133,1.133c.268.268.21.924-.3,1.438L9.977,14.432a1.6,1.6,0,0,1-.721.425l-1.523.391a.742.742,0,0,1-.716-.122.734.734,0,0,1-.122-.715Z",
    transform: "translate(2.849 0.026)",
    fill: "#d9a239"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImageEditeIcons);
export default __webpack_public_path__ + "static/media/hero_imageEdite_Icons.7f811dd2fa4d34767edbcf052dbc90df.svg";
export { ForwardRef as ReactComponent };